import { appConfig, getBrand, getRegion, getRuntimeEnvironment, regions } from '@planner/config';

export const brand = getBrand(import.meta.env.VITE_BRAND ?? appConfig.defaultBrand);
export const region = getRegion(import.meta.env.VITE_REGION ?? regions[0].code);
export const environment = getRuntimeEnvironment(
  import.meta.env.VITE_ENVIRONMENT ?? (import.meta.env.PROD ? 'prod' : 'local'),
);
export const appVersion = import.meta.env.VITE_APP_VERSION ?? 'v0.0.0-local';
export const apiBaseUrl = import.meta.env.VITE_API_URL ?? 'http://localhost:3131/api';

export { appConfig };
